import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { buildApiUrl } from "@/config/api";
import { REVERB_URL } from "@/config/api";

// Declare Pusher on window for Laravel Echo
declare global {
	interface Window {
		Pusher: typeof Pusher;
		Echo: Echo<any> | null;
	}
}

// Initialize Pusher on window
if (typeof window !== "undefined") {
	window.Pusher = Pusher;
}

let echoInstance: Echo<any> | null = null;

/**
 * Initialize Laravel Echo with authentication
 * @param accessToken - Bearer token for authentication
 * @param userId - User ID for private channel subscription
 */
export const initializeEcho = (accessToken: string, _userId: string | number): Echo<any> => {
	// Clean up existing instance if any
	if (echoInstance) {
		disconnectEcho();
	}

	const authEndpoint = buildApiUrl("/broadcasting/auth");
	const wsHost = REVERB_URL;
	const wsPort = import.meta.env.VITE_PUSHER_PORT || 443;
	const appKey = import.meta.env.VITE_PUSHER_APP_KEY || "xergdcgu7exkqxijwylj";



	const echo = new Echo({
		broadcaster: "reverb",
		key: appKey,
		wsHost: wsHost,
		wsPort: wsPort,
		wssPort: wsPort,
		forceTLS: true,
		enabledTransports: ["ws", "wss"],
		authEndpoint: authEndpoint,
		auth: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				Accept: "application/json",
			},
		},
	});

	// Add connection event listeners for debugging
	// const pusher = echo.connector.pusher; // Reserved for future use
	


	echoInstance = echo;
	window.Echo = echo;

	return echo;
};

/**
 * Get the current Echo instance
 */
export const getEcho = (): Echo<any> | null => {
	return echoInstance;
};

/**
 * Disconnect and clean up Echo instance
 */
export const disconnectEcho = (): void => {
	if (echoInstance) {
		echoInstance.disconnect();
		echoInstance = null;
		window.Echo = null;
	}
};

/**
 * Subscribe to a private channel
 * @param channelName - Channel name (e.g., "user.123")
 */
export const subscribeToPrivateChannel = (channelName: string): ReturnType<Echo<any>["private"]> | null => {
	if (!echoInstance) {
		console.warn("Echo instance not initialized");
		return null;
	}
	return echoInstance.private(channelName);
};

/**
 * Unsubscribe from a private channel
 * @param channelName - Channel name
 */
export const unsubscribeFromPrivateChannel = (channelName: string): void => {
	if (!echoInstance) {
		return;
	}
	try {
		echoInstance.leave(channelName);
	} catch (error) {
		console.error("Error unsubscribing from channel:", error);
	}
};

